import { useUserData } from '@lib/userData/UserDataProvider';
import { FlexColPageContainer } from '../../../components/FlexColPageContainer';
import { Heading } from '../Heading';
import { MoodSelectionForm } from './MoodSelectionForm';

export const metadata = {
  title: 'Mood Step 1 | Patchooli',
  description: 'Mood Log Entry | Step 1 | Patchooli',
};

export const MoodLogEntryStep1Page = () => {
  const [userData] = useUserData();
  const greetingName = userData?.profile?.firstName || 'friend';

  return (
    <FlexColPageContainer className="justify-start pt-2.5">
      <Heading className="mb-7">
        Hi {greetingName},<br />
        what&apos;s your mood like today?
      </Heading>
      <MoodSelectionForm />
    </FlexColPageContainer>
  );
};
